module.exports = __webpack_public_path__ + "img/yishi14.edd547e7.jpg";